import React, { FunctionComponent } from 'react'
import { Modal } from 'reactstrap'
import { useTranslation } from 'react-i18next'

interface ModalComponentProps {
  modalIsOpen: boolean
  toggle: () => void
}

const ModalComponent: FunctionComponent<ModalComponentProps> = ({
  modalIsOpen,
  toggle,
}) => {
  const { t } = useTranslation()

  return (
    <div>
      <Modal
        fade={false}
        className="modal-warning"
        isOpen={modalIsOpen}
        modalClassName="ltr-support"
        toggle={toggle}
        backdrop="static"
      >
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            onClick={toggle}
          />
          <p style={{ marginBottom: '0px' }}>
            {t('errorsPage.serverOverloaded')}
          </p>
        </div>
      </Modal>
    </div>
  )
}

export default ModalComponent
